module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    attrs: {
      "id": "header",
      "ref:header": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.ishowchina.com",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./images/chebanlvlogo2.png")
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://chebanlv.ishowchina.com/trackcloud/track.htm",
      "target": "_blank"
    }
  }, [_vm._v("轨迹云")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://v.ishowchina.com/",
      "target": "_blank"
    }
  }, [_vm._v("大数据可视化")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://clw.ishowchina.com:89/mygpsonline",
      "target": "_blank"
    }
  }, [_vm._v("位置服务平台")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1147dde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/decorator/header.vue
// module id = 145
// module chunks = 1